// 카카오 알림톡 미리보기 카드 — 이미 완성된 발송 원문(content)과 버튼 라벨만 받아 그대로 그려준다.
// scheduler/views/KakaoTemplatePreview.tsx의 동명 컴포넌트와 UI가 동일하다(그쪽은 자기
// 승인 템플릿 문구를 직접 조합해 넘기고, 여기(공통 컴포넌트)는 실제 템플릿 원문을
// #{변수} 치환해서 넘긴다는 차이만 있음 — 렌더링 자체는 그대로 재사용 가능해 복사해왔다).
export interface KakaoMessageCardProps {
  /** 템플릿 치환이 끝난 발송 원문 */
  content: string;
  /** 하단 버튼 라벨 목록 — 승인 템플릿의 실제 버튼 이름 그대로 */
  buttons: string[];
}

export function KakaoMessageCard({ content, buttons }: KakaoMessageCardProps) {
  return (
    <div style={{ borderRadius: 16, overflow: 'hidden', border: '1px solid var(--shell-border)' }}>
      {/* 카카오 브랜드 헤더 — 라이트/다크 무관 고정색이라 brand·primitive 토큰을 쓴다 */}
      <div style={{ background: 'var(--brand-kakao-symbol)', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ fontSize: 20, lineHeight: 1 }}>💬</div>
        <div>
          <div style={{ fontSize: 9.5, color: 'var(--warm-peach-300)', letterSpacing: '.4px' }}>카카오 알림톡</div>
          <div style={{ fontSize: 'var(--type-caption-size)', fontWeight: 700, color: 'var(--gray-0)' }}>인디피아</div>
        </div>
      </div>
      <div style={{ background: 'var(--shell-surface)', padding: '14px 14px', fontSize: 'var(--type-caption-size)', lineHeight: 1.7, color: 'var(--shell-on-surface)', whiteSpace: 'pre-line' }}>
        {content}
      </div>
      {buttons.length > 0 && (
        <div style={{ display: 'flex', borderTop: '1px solid var(--shell-border)', background: 'var(--shell-surface)' }}>
          {buttons.map((label, i) => (
            <div key={label} style={{ flex: 1, padding: '11px 0', textAlign: 'center', fontSize: 'var(--type-caption-size)', fontWeight: 600, color: 'var(--shell-on-surface)', borderLeft: i > 0 ? '1px solid var(--shell-border)' : undefined }}>
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
